import React from 'react';
import { useAuth } from './AuthContext';
import CreaEvento from './CreaEvento';


const HomePage = () => {
  const { jwtToken, logout } = useAuth();

  return (
 
      <div className='page-content'>
        <center>
          <img src="/logo.png" alt="ApuliaPrenota logo" />
        </center>
     
      <div className="main-content container">
       
          <div>
            <p>Apulia Prenota è la tua porta d'accesso esclusiva alle meraviglie della Puglia, una piattaforma innovativa che connette viaggiatori e residenti con il meglio che questa regione ha da offrire.</p>
            <p>Attraverso la nostra app, avrai a portata di mano un'ampia gamma di servizi selezionati con cura per esaltare la tua esperienza in Puglia: dalla cucina autentica, con aperitivi e degustazioni che celebrano i sapori locali, ai servizi sole e mare, inclusi esclusivi tour in barca e accessi privilegiati alle spiagge più incantevoli.</p>
            <p>Apulia Prenota offre anche informazioni dettagliate e prenotazioni per collegamenti di trasporto, rendendo ogni spostamento un'esperienza fluida e senza stress. Con un'interfaccia intuitiva e una guida affidabile ai luoghi di interesse, la nostra app è il tuo compagno indispensabile per esplorare la bellezza, la cultura e l'ospitalità uniche della Puglia.</p>
          </div>
       
      </div>
      </div>
 );
};

export default HomePage;
